import { render, staticRenderFns } from "./NotifyTemplateManage.vue?vue&type=template&id=01c2d486"
import script from "./NotifyTemplateManage.vue?vue&type=script&lang=js"
export * from "./NotifyTemplateManage.vue?vue&type=script&lang=js"
import style0 from "./NotifyTemplateManage.vue?vue&type=style&index=0&id=01c2d486&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports